const dateFormat = new Intl.DateTimeFormat("ja-JP", {
  timeZone: "Asia/Tokyo",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

const dateTimeFormat = new Intl.DateTimeFormat("ja-JP", {
  timeZone: "Asia/Tokyo",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
});

function parse(value: string | null | undefined): Date | null {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** 2026/10/14 */
export function formatDate(value: string | null | undefined): string | null {
  const date = parse(value);
  return date === null ? null : dateFormat.format(date);
}

/** 2026/10/14 09:12 */
export function formatDateTime(value: string | null | undefined): string | null {
  const date = parse(value);
  return date === null ? null : dateTimeFormat.format(date);
}

/** アイコンが無いときに出す頭文字 */
export function initialOf(name: string | null | undefined): string {
  const trimmed = name?.trim() ?? "";
  return trimmed === "" ? "?" : (Array.from(trimmed)[0] ?? "?").toUpperCase();
}

/** "Mozilla/5.0 (iPhone; ...) ... Safari/605" → "Safari · iPhone"。分からなければ null */
export function summarizeUserAgent(userAgent: string | null | undefined): {
  label: string | null;
  mobile: boolean;
} {
  if (!userAgent) return { label: null, mobile: false };
  const ua = userAgent;
  const os = /iPhone/.test(ua)
    ? "iPhone"
    : /iPad/.test(ua)
      ? "iPad"
      : /Android/.test(ua)
        ? "Android"
        : /Windows/.test(ua)
          ? "Windows"
          : /Mac OS X|Macintosh/.test(ua)
            ? "macOS"
            : /CrOS/.test(ua)
              ? "ChromeOS"
              : /Linux/.test(ua)
                ? "Linux"
                : null;
  const browser = /Edg\//.test(ua)
    ? "Microsoft Edge"
    : /OPR\//.test(ua)
      ? "Opera"
      : /Firefox\/|FxiOS/.test(ua)
        ? "Firefox"
        : /Chrome\/|CriOS/.test(ua)
          ? "Google Chrome"
          : /Safari\//.test(ua)
            ? "Safari"
            : null;
  const parts = [browser, os].filter((v): v is string => v !== null);
  return {
    label: parts.length === 0 ? null : parts.join(" · "),
    mobile: os === "iPhone" || os === "Android",
  };
}
